import React, { useEffect, useState, useContext } from "react";
import henceforthApi from "../utils/henceforthApi";
import { GlobalContext } from "../context/Provider";
import Swal from "sweetalert2";
import PaginationLayout from "../components/PaginationLayout";
import { Link, useLocation, useMatch, useNavigate } from "react-router-dom";
import AgGridTable from "../components/ui/AgGridTable";
import { ColDef } from "ag-grid-community";
interface reportby{
  account_type:string
  user_name:string,
  _id:string
}
interface user_id{
  _id:string
  user_name:string
  account_type:string
}
interface userReport{
  reported_by:reportby
  user_id:user_id
  reason:string
  _id:string
}
export default () => {
  const navigate = useNavigate();
  const location = useLocation();
  const match:any = useMatch("/reports/users/:page");

  const newParam = new URLSearchParams(location.search);

  const { authState } = useContext(GlobalContext);
  const [state, setState] = useState({
    data: [] as Array<userReport>,
    total_count: 0,
  });

  const [readContent, setReadContent] = useState("");
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState("");
  if(authState.access_token){henceforthApi.setToken(authState.access_token);}

  const onChangePagination = (newVal:number) => {
    if (newParam.has("search")) {
      navigate(`/reports/users/${newVal}?search=${newParam.get("search")}`);
    } else {
      navigate(`/reports/users/${newVal}`);
    }
  };

  const onClearSearch = () => {
    const newSearchparams = new URLSearchParams();
    navigate({ search: newSearchparams.toString() });
  };
  const onSearch = async (searchData:string) => {
    if (searchData) {
      navigate(`/reports/users/1?search=${searchData}`);
    } else {
      navigate(`/reports/users/1`);
    }
  };
  const initialiseData = async () => {
    try {
      let apiRes = await henceforthApi.Reports.pagination(
        Number(match.params.page) - 1
      );

      setState({
        ...state,
        ...apiRes.data,
      });
      // setLoading(false);
    } catch (error:any) {
      // setLoading(false);
    }
  };
  useEffect(() => {
    const init = async () => {
      // setLoading(true);
      let searchData = newParam.has("search") ? newParam.get("search") : "";
      initialiseData();
    };
    init();
  }, [match.params.page, newParam.get("search")]);

  const handleResolve = (id:string) => {
    const data = {
      language: "ENGLISH",
      type: "RESOLVE",
      _id: id,
    };
    console.log("resolved");

    henceforthApi.ContactUs.resolveContact(data)
      .then((res:any) => {
        console.log(res, "Resolved succesfully");
        Swal.fire({
          title: "Contact Resolved",
          text: "Contract Resolved successfully",
          icon: "success",
          confirmButtonText: "OK",
        });
        initialiseData();
      })
      .catch((err:any) => {
        console.log("delte failed", err);
        Swal.fire({
          title: "Contact Resolved",
          text: err.response.body.error_description,
          icon: "error",
          confirmButtonText: "Cancel",
        });
      });
  };

  const handleDelete = (id:string) => {
    console.log("deleted");

    const data = {
      language: "ENGLISH",
      type: "DELETE",
      _id: id,
    };
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then(async (result:any) => {
      if (result.isConfirmed) {
        try {
          henceforthApi.ContactUs.deleteContact(data)
            .then((res:any) => {
              console.log(res, "Deleted succesfully");

              Swal.fire({
                title: "Contact Deleted",
                text: "Contract deletd successfully",
                icon: "success",
                confirmButtonText: "OK",
              });
              initialiseData();
            })
            .catch((err:any) => {
              console.log("delte failed", err);
              Swal.fire({
                title: "Contact Delete Failed",
                text: err.response.body.error_description,
                icon: "error",
                confirmButtonText: "Cancel",
              });
            });
        } catch (error:any) {
          
        }
      }
    });
  };

  const columnDefs = React.useMemo<ColDef[]>(() => {
    return [
      {
        headerName: "Sr No.",
        field: "_id",
        minWidth: 70,
        width: 80,
        valueGetter: (p) => {
          const page = Number(match?.params?.page || 1);
          const index = p.node?.rowIndex ?? 0;
          return `${(page - 1) * 10 + index + 1}.`;
        },
      },
      {
        headerName: "Reported By",
        field: "reported_by.user_name",
        minWidth: 160,
        cellRenderer: (p: any) => {
          const item = p.data?.reported_by;
          if (!item) return <span className="text-slate-400">N/A</span>;
          const role = item.account_type === "CREATER" ? "creator" : "user";
          return (
            <Link
              to={`/${role}/${item._id}`}
              className="text-[#006747] font-semibold hover:underline text-xs"
            >
              {item.user_name || "N/A"}
            </Link>
          );
        },
      },
      {
        headerName: "Reported To",
        field: "user_id.user_name",
        minWidth: 160,
        cellRenderer: (p: any) => {
          const item = p.data?.user_id;
          if (!item) return <span className="text-slate-400">Not found</span>;
          const role = item.account_type === "CREATER" ? "creator" : "user";
          return (
            <Link
              to={`/${role}/${item._id}`}
              className="text-slate-700 font-medium hover:text-[#006747] text-xs"
            >
              {item.user_name || "Not found"}
            </Link>
          );
        },
      },
      {
        headerName: "Report Reason",
        field: "reason",
        minWidth: 260,
        flex: 1.5,
        cellRenderer: (p: any) => {
          const reason = p.value || "Not found";
          return (
            <span
              onClick={() => setReadContent(reason)}
              data-bs-toggle="modal"
              data-bs-target="#readContentModal"
              className="cursor-pointer text-slate-700 hover:text-[#006747] truncate block text-xs"
              title="Click to view details"
            >
              {reason}
            </span>
          );
        },
      },
    ];
  }, [match?.params?.page]);

  return (
    <>
      <AgGridTable
        rowData={state.data || []}
        columnDefs={columnDefs}
        loading={false}
        domLayout="autoHeight"
        emptyMessage="No user reports found"
      />

      <div className="mt-3">
        <PaginationLayout
          count={state.total_count}
          data={state.data}
          page={Number(match?.params?.page || 1)}
          limit={10}
          loading={false}
          onPageChange={(val) => onChangePagination(val)}
        />
      </div>

      <div
        className="modal fade"
        id="readContentModal"
        tabIndex={-1}
        aria-labelledby="readContentModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content rounded-xl border border-slate-200 shadow-lg overflow-hidden">
            <div className="modal-header bg-slate-50 border-b border-slate-100 px-4 py-3">
              <h5 className="modal-title text-sm font-bold text-slate-800">
                Report Reason
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body p-4">
              <p className="text-slate-700 text-sm leading-relaxed text-break mb-0">
                {readContent}
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
